export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/channel-bank.ab005b08-8d3209.svg";